export default __webpack_public_path__ + "static/media/black-arrow-right.978632e6.svg";